<template>
    <div class="row scrollable events bg-white">
        <div class="col-12 mb-3 mt-3">
            <h3>{{ $t('pages.admin.Events') }}</h3>
        </div>
        <div class="col-8">
            <input class="form-control" :placeholder="$t('fields.Search')" v-model="filter"
                   @input="($event) => { filter = $event.target.value; filterResults()}">
        </div>
        <div class="col-4 text-right">
            <event-create-modal/>
        </div>
        <div class="col mt-4">
            <loading :name="loaderName">
                <table class="table table-striped table-sm table-borderless">
                    <thead>
                    <th>{{$t('fields.Name')}}</th>
                    <th>{{$t('fields.Theme')}}</th>
                    <th>{{$t('fields.StartRegistrationDate')}}</th>
                    <th>{{$t('fields.EndVolunteerRegistrationDate')}}</th>
                    <th>{{$t('fields.EndRegistrationDate')}}</th>
                    <th class="long-th">{{$t('fields.Actions')}}</th>
                    </thead>
                    <tbody v-if="list && list.data">
                    <tr v-for="event in list.data" :key="'event-'+event.id">
                        <td><b>{{event.name}}</b></td>
                        <td>{{event.theme}}</td>
                        <td>{{event.start_registration | formatTime('ddd DD.MM')}}</td>
                        <td>{{event.end_volunteer_registration | formatTime('ddd DD.MM')}}</td>
                        <td>{{event.end_registration | formatTime('ddd DD.MM')}}</td>
                        <td>
                            <router-link class="fas fa-user-friends col-3 hand"
                                         :to="'/admin/events/' + event.id + '/groups'"
                                         :title="$t('button.Groups')"></router-link>
                            <router-link class="fas fa-list-ul col-3 hand"
                                         :to="'/admin/events/' + event.id + '/participants'"
                                         :title="$t('button.ParticipantList')"></router-link>
                            <router-link class="fas fa-pencil-alt col-3 hand" :title="$t('button.Edit')"
                                         :to="'/admin/events/' + event.id + '/edit'"></router-link>
                            <router-link class="fas fa-info hand col-3" :title="$t('button.Detail')"
                                         :to="'/admin/events/' + event.id"></router-link>
                        </td>
                    </tr>
                    </tbody>
                    <tr v-else class="text-center">
                        <td colspan="9">{{$t('errorMessages.NO_DATA')}}</td>
                    </tr>
                </table>
                <paginate
                        v-if="list && list.last_page"
                        v-model="page"
                        :page-count="list.last_page"
                        :click-handler="changePage"
                        :prev-text="$t('button.Prev')"
                        :next-text="$t('button.Next')"
                        :page-class="'page-item'"
                        :container-class="'pagination justify-content-center'">
                </paginate>
            </loading>
        </div>
    </div>
</template>

<script>
  import {mapActions} from 'vuex';
  import {ROUTER_NAMES} from '../../constants';
  import EventCreateModal from '../../components/events/EventsCreateModal';
  import paginationMixin from '../../mixins/paginationMixin';
  import filterMixin from '../../mixins/filterMixin';

  export default {
    name: 'Events',
    components: {
      EventCreateModal
    },
    mixins: [paginationMixin, filterMixin],
    created() {
      this.$wait.start(this.loaderName);

      this.loadVolunteerTypes()
        .then(() => {
          this.filters = [{
            name: 'p',
            type: 'string',
          }, {
            name: 'filter',
            type: 'string'
          }];
          this.resolveFilters();
          this.loadContent().then(() => {
            this.$wait.end(this.loaderName);
          });
        })
        .catch(e => {
          this.$router.push({
            name: ROUTER_NAMES.ERROR
          });
        });
    },
    data() {
      return {
        filter: '',
        routeName: ROUTER_NAMES.ADMIN_EVENTS,
        loaderName: 'load events',
        clearAction: 'clearEvents'
      };
    },
    methods: {
      ...mapActions(['loadEvents', 'loadVolunteerTypes']),
      loadContent(page) {
        return this.loadEvents({
          page: page || this.page,
          filter: this.filter
        });
      },
    },
    computed: {
      items() {
        return this.$store.state.admin.events;
      }
    }
  };
</script>

<style scoped>
</style>
